import { Checkbox, FormControlLabel } from "@mui/material";
import Alert from "@mui/material/Alert";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

import Cookies from "js-cookie";
import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import { CASH_ACTIVITY_TYPES } from "../../constants";

import {
    createNewCashRegister,
    getOrganizationById,
} from "../../services/requests/GraphRequests";
import RU from "../../services/translation/ru.json";
import { translation } from "../../services/translation/translation";
import { validateCashRegister } from "../../services/Validations";

export default function AddCashRegister() {
    let navigate = useNavigate();
    let params = useParams();
    const { companyId = "" } = params || {};

    const [loading, setLoading] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);
    const [company, setCompany] = React.useState({});
    const [dict, setDict] = React.useState(RU);

    const [formValidationError, setFormValidationError] = React.useState({
        address: true,
        model: true,
        factory: true,
        number: false,
        key: false,
        subdivision: false,
        point: false,
    });

    React.useEffect(() => {
        getOrganizationById(companyId).then((data) => {
            setCompany(data.data.organization);
            setLoading(false);
        });
        if (Cookies.get("simpalsid.lang")) {
            setDict(translation(Cookies.get("simpalsid.lang")));
        } else {
            setDict(translation("ru"));
        }
    }, [companyId]);

    let [cashRegister, setCashRegister] = React.useState({
        address: "",
        number: "",
        key: "",
        subdivision: "",
        point: "",
        deleted: false,
    });

    let [readyToSave, setReadyToSave] = React.useState(false);

    const [openSuccess, setOpenSuccess] = React.useState(false);
    const [error, setError] = React.useState({
        status: false,
        msg: "Error",
    });

    React.useEffect(() => {
        let validateResult = validateCashRegister(cashRegister);
        setReadyToSave(validateResult.validation);
        setFormValidationError(validateResult.errors);
    }, [cashRegister, setCashRegister]);

    React.useEffect(() => {
        if (openSuccess) {
            setTimeout(function () {
                navigate(`/company/${company.id}`);
            }, 3500);
        }
    }, [company.id, navigate, openSuccess, setOpenSuccess]);

    const handleChange = (event) => {
        const value =
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value;

        setCashRegister({
            ...cashRegister,
            [event.target.name]: value,
        });
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSuccess(false);
        setError({
            status: false,
            msg: "Error",
        });
    };

    function saveCashRegister() {
        setIsSaving(true);
        createNewCashRegister(cashRegister, company.id).then((data) => {
            if (data.data.data?.createCashRegister?.id) {
                setOpenSuccess(true);
            } else {
                let msgError = "There are errors while receipt generation";
                if (data.data.errors.length > 0) {
                    msgError = data.data.errors[0].message;
                }
                setIsSaving(false);
                setError({
                    status: true,
                    msg: msgError,
                });
            }
        });
    }

    if (loading) {
        return (
            <div align="center">
                <CircularProgress />
            </div>
        );
    }

    if (company.cashRegistersCount > 0) {
        return (
            <Box
                sx={{
                    flexGrow: 1,
                    marginTop: 3,
                    marginLeft: 10,
                    marginBottom: 10,
                }}
            >
                <Grid
                    container
                    sx={{ marginTop: 2 }}
                    spacing={4}
                    align="center"
                >
                    <Grid item xs={12}>
                        <Typography
                            sx={{ fontSize: 24, marginTop: 5 }}
                            color="error"
                            gutterBottom
                        >
                            {dict.cash_register_already_exists}
                        </Typography>
                        <Typography
                            sx={{ fontSize: 16, marginTop: 2 }}
                            color="text.secondary"
                            gutterBottom
                        >
                            {dict.only_one_cash_register_allowed}
                        </Typography>
                        <Button
                            variant="outlined"
                            sx={{ marginTop: 3 }}
                            onClick={() => {
                                navigate(`/company/${company.id}`);
                            }}
                        >
                            {dict.go_back}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        );
    }

    return (
        <Box
            sx={{ flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10 }}
        >
            <Grid container sx={{ marginTop: 2 }} spacing={4} align="left">
                <Grid item xs={7}>
                    <Typography
                        sx={{ fontSize: 24 }}
                        color="pimary"
                        gutterBottom
                    >
                        {dict.add_cash_register_for_organization}
                    </Typography>
                    <Button
                        variant="text"
                        color="secondary"
                        onClick={() => {
                            navigate(`/company/${company.id}`);
                        }}
                    >
                        &#60; {dict.go_back}
                    </Button>
                </Grid>
                <Grid item xs={4} align="right">
                    <Button
                        variant="outlined"
                        disabled={!readyToSave || isSaving}
                        onClick={() => {
                            saveCashRegister();
                        }}
                    >
                        {dict.save}
                    </Button>
                </Grid>
                {/* Organization info */}
                <Grid container item xs={12} spacing={1} align="left">
                    <Grid item xs={6}>
                        <Grid container spacing={1} align="left">
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.idno}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.idno}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.organization_name}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.organization_phone}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.organizationPhone}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.organization_email}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.organizationEmail}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={5}>
                        <Grid container spacing={1} align="left">
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.contact_person}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.contact}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.contact_person_phone}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.contactPhone}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {dict.contact_person_email}:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    sx={{ fontSize: 14 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {company.contactEmail}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 2 }} spacing={4} align="left">
                <Grid item xs={5}>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.address}
                        </InputLabel>
                        <Input
                            id="component-simple"
                            value={cashRegister.address}
                            onChange={handleChange}
                            name="address"
                            aria-describedby="standard-helper-text"
                            inputProps={{
                                "aria-label": "text",
                            }}
                            error={formValidationError.address}
                        />
                        <FormHelperText id="standard-helper-text">
                            {dict.address_sale_point}
                        </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.point}
                        </InputLabel>
                        <Input
                            id="component-simple"
                            value={cashRegister.point || ""}
                            onChange={handleChange}
                            name="point"
                            aria-describedby="standard-helper-text"
                            inputProps={{ "aria-label": "text" }}
                            error={formValidationError.point}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.activity_type}
                        </InputLabel>
                        <Select
                            variant={"standard"}
                            value={cashRegister.activityType}
                            onChange={handleChange}
                            name="activityType"
                            aria-describedby="standard-helper-text"
                            inputProps={{ "aria-label": "text" }}
                            error={formValidationError.activityType}
                        >
                            <MenuItem value={null}>-</MenuItem>
                            {Object.keys(CASH_ACTIVITY_TYPES).map(
                                (type, index) => (
                                    <MenuItem
                                        key={`${type + index}`}
                                        value={type}
                                    >
                                        {
                                            dict?.[
                                                `activity_${type.toLocaleLowerCase()}`
                                            ]
                                        }
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <FormControlLabel
                            control={<Checkbox />}
                            label="Disabled"
                            checked={cashRegister.deleted || false}
                            name="deleted"
                            onChange={handleChange}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.registration_number}
                        </InputLabel>
                        <Input
                            id="component-simple"
                            value={cashRegister.number}
                            onChange={handleChange}
                            name="number"
                            aria-describedby="standard-helper-text"
                            inputProps={{
                                "aria-label": "text",
                            }}
                            error={formValidationError.number}
                        />
                        <FormHelperText id="standard-helper-text">
                            {dict.registration_number} MEV
                        </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.key}
                        </InputLabel>
                        <Input
                            id="component-simple"
                            value={cashRegister.key}
                            onChange={handleChange}
                            name="key"
                            aria-describedby="standard-helper-text"
                            inputProps={{
                                "aria-label": "text",
                            }}
                            error={formValidationError.key}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="component-simple">
                            {dict.subdivision}
                        </InputLabel>
                        <Input
                            id="component-simple"
                            value={cashRegister.subdivision || ""}
                            onChange={handleChange}
                            name="subdivision"
                            aria-describedby="standard-helper-text"
                            inputProps={{ "aria-label": "text" }}
                            error={formValidationError.subdivision}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Snackbar
                open={openSuccess}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    Cash register created!
                </Alert>
            </Snackbar>
            <Snackbar
                open={error.status}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {error.msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}
